<template>
  <el-dialog
    title="Update"
    custom-class="update-dialog"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="75%"
    top="2em"
    :visible.sync="dialogVisible"
    :fullscreen="$mq === 'xs'"
  >
    <div>
      <el-select
        class="no-border"
        style="width:100%;"
        v-model="tupdate.user_id"
        placeholder="On Behalf of"
      >
        <el-option
          v-for="item in users"
          :key="item.o_id"
          :label="item.primary_position == null ? item.firstName + ' ' + item.lastName : item.firstName + ' ' + item.lastName +  ' - ' + item.primary_position.name"
          :value="item.o_id"
        ></el-option>
      </el-select>
      <el-input class="no-border" placeholder="Title" v-model="tupdate.update_title"></el-input>
      <div class="flex">
        <el-select
          class="no-border"
          style="display: inline-block; width:50%;"
          v-model="tupdate.destination"
          multiple
          placeholder="Select Recipients"
        >
          <el-option
            v-for="item in distributionList"
            :key="item.o_id"
            :label="item.name"
            :value="item.o_id"
          ></el-option>
        </el-select>
        <el-select
          class="no-border"
          style="display: inline-block; width:50%;"
          v-model="tupdate.term"
          value-key="term"
          placeholder="Select Term"
        >
          <el-option v-for="item in terms" :key="item.term" :label="item.name" :value="item"></el-option>
        </el-select>
      </div>
      <hr style="margin-top: 4px;" />
      <vue-editor
        class="update-editor"
        style="margin-bottom: 16px;"
        v-model="tupdate.update_text"
        :editorOptions="bodyEditorOption"
      ></vue-editor>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">Cancel</el-button>
        <el-button type="primary" @click="saveUpdate">Confirm</el-button>
      </span>
    </div>
  </el-dialog>
</template>
<style>
</style>

<script>
export default {};
</script>

<style>
</style>

<script>
import { mapFields } from "vuex-map-fields";
import { VueEditor, Quill } from "vue2-editor";

var Clipboard = Quill.import("modules/clipboard");
var Delta = Quill.import("delta");

class PlainClipboard extends Clipboard {
  convert(html = null) {
    if (typeof html === "string") {
      this.container.innerHTML = html;
    }
    const text = this.container.innerText;
    this.container.innerHTML = "";
    return new Delta().insert(text);
  }
}

Quill.register("modules/clipboard", PlainClipboard, true);

export default {
  props: ["update", "dialogVisible"],
  components: {
    VueEditor
  },
  data() {
    return {
      tupdate: {
        destination: [],
        user_id: null,
        term: null,
        update_title: null,
        update_text: null,
        send_corps_email: true
      },
      bodyEditorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "link"],
            [{ indent: "-1" }, { indent: "+1" }],
            [{ list: "ordered" }, { list: "bullet" }]
          ]
        },
        placeholder: "Write the update here..."
      }
    };
  },
  created() {
    if (this.update != null)
      this.tupdate = JSON.parse(JSON.stringify(this.update));
  },
  computed: {
    ...mapFields(["user", "users", "terms", "distributionList"])
  },
  watch: {
    tupdate(after, before) {
      if (after.user_id == null) {
        return;
      }
      if (before.user_id != after.user_id) {
        this.update_user = this.users.filter(
          cad => cad.o_id == after.user_id
        )[0];
        if (this.update_user == null) {
          this.getDeletedUser(after.user_id);
        }
      }
      if (
        before.destination != after.destination &&
        this.distributionList != null
      ) {
        this.destination_text = this.distributionList
          .filter(dest => this.tupdate.destination.includes(dest.o_id))
          .map(dest => dest.name)
          .join(", ");
      }
    },
    distributionList() {
      this.destination_text = this.distributionList
        .filter(dest => this.tupdate.destination.includes(dest.o_id))
        .map(dest => dest.name)
        .join(", ");
    }
  },
  mounted() {
    if (this.terms == null) this.$store.dispatch("pullTerms");
    if (this.update != null) {
      this.tupdate = JSON.parse(JSON.stringify(this.update));

      // JSON is saving boolean as integer
      this.tupdate.send_corps_email = Boolean(this.tupdate.send_corps_email);
    } else {
      this.tupdate.user_id = this.user.o_id;
    }
    if (this.distributionList == null)
      this.$store.dispatch("pullDistributionList");
    if (this.users == null) this.$store.dispatch("pullUsers");
  },
  methods: {
    edit() {
      this.oldupdate = this.tupdate;
      this.editing = true;
    },
    close() {
      this.$emit("close");
      this.clear();
    },
    clear() {
      this.tupdate = {
        destination: [],
        user_id: null,
        term: null,
        update_title: null,
        update_text: null,
        send_corps_email: true
      };
    },
    saveUpdate() {
      if (!this.tupdate.term) {
        this.$message({
          showClose: true,
          message: "Must select a term.",
          type: "error"
        });
      } else if (!this.tupdate.update_text) {
        this.$message({
          showClose: true,
          message: "Must give update a body.",
          type: "error"
        });
      } else if (!this.tupdate.update_title) {
        this.$message({
          showClose: true,
          message: "Must give update a title.",
          type: "error"
        });
      } else if (this.tupdate.destination.length == 0) {
        this.$message({
          showClose: true,
          message: "Update must have recipients.",
          type: "error"
        });
      } else if (this.update != null && this.update.o_id) {
        this.axios
          .put(
            "/api/v1/updates/" + this.tupdate.o_id,
            {
              user_id: this.tupdate.user_id,
              update_title: this.tupdate.update_title,
              update_text: this.tupdate.update_text,
              term: this.tupdate.term.term,
              send_corps_email: this.tupdate.send_corps_email,
              destination: this.tupdate.destination
            },
            {
              headers: {
                "Content-Type": "application/json"
              },
              credentials: "same-origin"
            }
          )
          .then(response => {
            this.editing = false;
            this.$emit("close", response.data);
            this.clear();
            this.$message({
              showClose: true,
              message: "Update Saved",
              type: "success"
            });
          })
          .catch(err => {
            console.error(err);
            this.$message({
              showClose: true,
              message: err.response.data.message,
              type: "error"
            });
          });
      } else {
        this.axios
          .post(
            "/api/v1/updates",
            {
              user_id: this.tupdate.user_id,
              update_title: this.tupdate.update_title,
              update_text: this.tupdate.update_text,
              term: this.tupdate.term.term,
              send_corps_email: this.tupdate.send_corps_email,
              destination: this.tupdate.destination
            },
            {
              headers: {
                "Content-Type": "application/json"
              },
              credentials: "same-origin"
            }
          )
          .then(response => {
            this.$emit("close", response.data);
            this.clear();
            this.$message({
              showClose: true,
              message: "Update Saved",
              type: "success"
            });
          })
          .catch(err => {
            console.error(err);
            this.$message({
              showClose: true,
              message: err.response.data.message,
              type: "error"
            });
          });
      }
    },
    getDeletedUser(user_id) {
      this.axios
        .get("/api/v1/users/deleted/" + user_id, {
          headers: {
            "Content-Type": "application/json"
          },
          credentials: "same-origin"
        })
        .then(response => {
          this.update_user = response.data;
        })
        .catch(err => {
          console.error(err);
          this.$message({
            showClose: true,
            message: "Requested user does not exist.",
            type: "error"
          });
        });
    }
  }
};
</script>

